import React, { useState, useEffect } from "react";
import "./ServicesCard.css";

const cardData = [
  {
    id: 1,
    title: "Care Taker at Home",
    description:
      "Providing compassionate and personalized care tailored to your loved one's needs, ensuring safety, comfort, and emotional support at home.",
    points: [
      "Assistance with Daily Activities",
      "Companionship and Emotional Support",
      "Personal Hygiene and Grooming",
      "Medication Reminders",
      "24/7 Availability",
    ],
    images: [
      "https://img.freepik.com/free-photo/senior-man-nursing-home-with-dumbbells-doing-physiotherapy-with-help-from-nurse_482257-45268.jpg?t=st=1740383269~exp=1740386869~hmac=ca01424ca9897c089bd477622a1de67058132ed30f0a30a9848816d7fcd8f2b8&w=1380",
      "https://glimageurl.golocall.com/golocal-post/image/844721_fusionplus_1494914175.jpeg",
      "https://pragatihomecare.in/wp-content/uploads/2023/12/nurse.jpg",
    ],
  },

  {
    id: 2,
    title: "Senior Citizen Care at Home",
    description:
      "Specialized care for seniors focusing on maintaining independence, dignity, and quality of life with round-the-clock support.",
    points: [
      "Daily Living Assistance",
      "Health Monitoring and Vital Checks",
      "Emotional and Social Engagement",
      "Mobility and Exercise Support",
      "24/7 Availability",
    ],
    images: [
      "https://content.jdmagicbox.com/comp/service_catalogue/home-nursing-services-for-senior-citizen--0512px512.x512.221204133031.n7g4-qw3wdlo.jpg",
      "https://5.imimg.com/data5/SELLER/Default/2024/8/446435000/MJ/HJ/AN/228519376/home-nursing-care-services.jpg",
      "https://5.imimg.com/data5/SELLER/Default/2022/9/CJ/AW/OR/121852142/old-age-care-taker-500x500.jpg",
    ],
  },

  {
    id: 4,
    title: "Colostomy Care",
    description:
      "Expert colostomy care to ensure proper hygiene, comfort, and well-being for individuals with ostomy needs.",
    points: [
      "Cleaning and maintaining the stoma site",
      "Changing and emptying colostomy bags",
      "Skin protection and irritation prevention",
      "Proper disposal of medical waste",
      "24/7 Availability",
    ],
    images: [
      "https://colorectalsurgery.com.sg/wp-content/uploads/2024/04/unnamed-e1712046229593.png",
      "https://dm0qx8t0i9gc9.cloudfront.net/thumbnails/video/BgrICs-NZj4hksnn3/videoblocks-social-worker-or-nurse-helping-an-elderly-woman-to-walk-with-crutches-in-a-retirement-home_rewtulxfl_thumbnail-1080_06.png",
      "https://static.vecteezy.com/system/resources/thumbnails/040/082/626/small_2x/young-male-doctor-and-woman-helping-old-man-in-nursing-home-to-walk-with-crutches-video.jpg",
    ],
  },

  {
    id: 6,
    title: "Bedridden Patient Care",
    description:
      "Comprehensive care for bedridden patients to ensure comfort, hygiene, and medical attention.",
    points: [
      "Regular repositioning to prevent bedsores",
      "Assistance with feeding and hydration",
      "Hygiene care including sponge baths",
      "Monitoring vitals and medication administration",
      "24/7 Availability",
    ],
    images: [
      "https://shrimanjunathahomenursing.com/wp-content/uploads/2024/07/Importance-of-Home-Nurse-Services-for-Bedridden-Patients-960x563.webp",
      "https://www.shutterstock.com/image-photo/nursing-lady-embeds-senior-patient-600nw-1430172128.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDqdXeb1SxxNI5KWeytuHAuaYy70QljI7jnvKyHygnlZZ9wlb6LKB6b7_yfiO6h0wC-n8&usqp=CAU",
    ],
  },

  {
    id: 4,
    title: "All Injections at Home",
    description:
      "Professional nursing service for administering injections at home, ensuring safety and comfort in a familiar environment.",
    points: [
      "Insulin Injections",
      "IV and IM Injections",
      "Pain Management Injections",
      "Vaccine Administration",
      "24/7 Availability",
    ],
    images: [
      "https://activeplushomehealth.com/wp-content/uploads/2022/05/Nurse-giving-injection-to-male-patient.jpg",
      "https://5.imimg.com/data5/SELLER/Default/2022/2/FE/ZA/CT/123259219/1-1-.jpg",
      "https://kvmlifecare.com/wp-content/uploads/2022/08/sc-injection-1024x624.jpeg",
    ],
  },
  {
    id: 5,
    title: "Wound Dressing at Home",
    description:
      "Expert wound care services at home, promoting healing with sterile and advanced dressing techniques.",
    points: [
      "Post-Surgical Wound Care",
      "Diabetic Foot Ulcer Management",
      "Burn and Injury Dressing",
      "Infection Prevention",
      "24/7 Availability",
    ],
    images: [
      "https://5.imimg.com/data5/OB/RK/BP/ANDROID-84699422/prod-20200425-0948043662111211049733493-jpg-500x500.jpg",
      "https://blog.wcei.net/wp-content/uploads/2021/02/Leg-wound-and-gauze-GettyImages-103919213.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6KIuJhB6gJRCGofRnzp4JWALywyxjZ6I_fsIT-S5nonkg1pH681VVbFCDZXzW5l4tXcQ&usqp=CAU",
    ],
  },
  {
    id: 6,
    title: "Cancer Care at Home",
    description:
      "Compassionate and comprehensive cancer care in the comfort of home, supporting patients through all stages of treatment and recovery.",
    points: [
      "Pain and Symptom Management",
      "Emotional and Psychological Support",
      "Nutritional Counseling",
      "Post-Chemotherapy Care",
      "24/7 Availability",
    ],
    images: [
      "https://globalintensivecare.in/img/Oncology.jpg",
      "https://d2jx2rerrg6sh3.cloudfront.net/image-handler/picture/2021/1/shutterstock_1766049131.jpg",
      "https://www.asterhospitals.in/sites/default/files/styles/webp/public/2023-07/childhood-cancer.jpg.webp?itok=-w8XWccU",
    ],
  },
  {
    id: 7,
    title: "Post Surgical Care at Home",
    description:
      "Professional post-operative care ensuring a smooth recovery process with monitoring and assistance at home.",
    points: [
      "Pain Management and Medication Administration",
      "Wound Dressing and Care",
      "Mobility Assistance and Physiotherapy",
      "Nutritional Support and Hygiene Care",
      "24/7 Availability",
    ],
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkgLcui18ftrMrwSBgWR68eA5xOtJ9o9T65K-V9CwffBHFRVcDOR5iG0BUjxgoLD3y5NA&usqp=CAU",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyHPQxHZWvTltPPfhU2RhsXEqx98A8IiRJ3suujCkTCLgnm5v9vUBdtBXVn1NLly9UdcY&usqp=CAU",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToQc4gZbwJ3i6iD2_NJh_TYUyV3c3eQe8XdA&s",
    ],
  },
  {
    id: 8,
    title: "Catheter Care at Home",
    description:
      "Safe and hygienic catheter care at home by trained professionals to prevent infections and ensure patient comfort.",
    points: [
      "Catheter Insertion and Removal",
      "Cleaning and Maintenance",
      "Urine Bag Changing",
      "Infection Prevention",
      "24/7 Availability",
    ],
    images: [
      "https://activelifemed.com/wp-content/uploads/2024/08/shutterstock_2472677019-1080x675.jpg",
      "https://dm1zcrsul8wju.cloudfront.net/sites/rcn_nspace/files/styles/tile_image/public/Article-images/203176/81563.jpeg?itok=9V9zlIpW",
      "https://www.orlandohealth.com/-/media/images/blogs/2024/03/managing-your-foley-catheter-image.jpg",
    ],
  },
  {
    id: 9,
    title: "Tracheostomy Care at Home",
    description:
      "Specialized tracheostomy care by trained professionals ensuring respiratory comfort and infection control at home.",
    points: [
      "Tube Cleaning and Maintenance",
      "Suctioning and Airway Clearance",
      "Emergency Management",
      "Patient and Family Education",
      "24/7 Availability",
    ],
    images: [
      "https://kefihealthcare.com/wp-content/uploads/2022/01/trache-for-website.jpg",
      "https://sukinohealthcare.com/wp-content/uploads/2023/07/Tracheostomy-Care-in-Bangalore-1024x645.png",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQM4v7tbT6R24xD0VyqEOgX8ofoXVRYSz8ov3_C1MD1ljGE-PR84-6W6YYb0XRZglN7-xk&usqp=CAU",
    ],
  },
  {
    id: 10,
    title: "Psychiatric Care at Home",
    description:
      "Holistic psychiatric care at home, focusing on mental well-being and emotional support for a better quality of life.",
    points: [
      "Counseling and Therapy Sessions",
      "Medication Management",
      "Behavioral Support",
      "Crisis Intervention",
      "24/7 Availability",
    ],
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnlb3M63LNTVaKb6K1jD6nX7ia-_WahwIt1w&s",
      "https://s3.amazonaws.com/utep-uploads/wp-content/uploads/DUQ-MIG/2018/12/07114159/nurse-talking-to-a-young-patient.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrdkAGVSlSSZkapofsYpob7ArMQ3wqUpOTYVAZcrLnyWj2NpA5GuGEeFV0Dy1DijpOJnA&usqp=CAU",
    ],
  },
  {
    id: 11,
    title: "Stroke Care at Home",
    description:
      "Comprehensive post-stroke care promoting recovery and independence through tailored rehabilitation programs at home.",
    points: [
      "Physiotherapy and Mobility Support",
      "Speech and Cognitive Therapy",
      "Daily Living Assistance",
      "Nutritional and Emotional Support",
      "24/7 Availability",
    ],
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbCIknOh3nh5oj3PEESVUN9NzNX9Dym0vkbw&s",
      "https://mobilitycentre.co.nz/wp-content/uploads/2019/09/Stroke-resized-1030x687.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvoOWJSGLi1GMYoS6DynmNceLRlcF6UmUFYCHfELTmksfZp8OyX7E6SD0yg8s4Mt9SdXs&usqp=CAU",
    ],
  },
  {
    id: 12,
    title: "Physiotherapy at Home",
    description:
      "Personalized physiotherapy sessions at home to enhance mobility, strength, and overall well-being.",
    points: [
      "Orthopedic Rehabilitation",
      "Neurological Physiotherapy",
      "Post-Surgical Rehabilitation",
      "Pain Management and Exercise Therapy",
      "24/7 Availability",
    ],
    images: [
      "https://postureclinic.in/wp-content/uploads/2023/01/4-1.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSAWvIRn1xR4VldHgfBThA6Gj40Pr1-N2JoRPrT6G_yS55chSRlCdgAjqVXtPHvh7W944&usqp=CAU",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLb5NrZ9XvppvfSElPorv1k61EN9HzxzLmJC0z4Z8d2C7-vUqz7oKx62--HGl3A1bMKts&usqp=CAU",
    ],
  },
  {
    id: 3,
    title: "Elder Care at Home",
    description:
      "Compassionate and professional care to support seniors in their daily lives, ensuring comfort, safety, and well-being at home.",
    points: [
      "Daily assistance with routine activities",
      "Health monitoring and medication reminders",
      "Emotional and social engagement",
      "Mobility support and light exercises",
      "24/7 Availability",
    ],
    images: [
      "https://livewell.care/wp-content/uploads/2022/08/Frail-Care-Facility-Home-Livewell-Estates-1-1080x675.png",
      "https://goldenheartwalnutcreek.com/wp-content/uploads/sites/17/2022/05/bigstock-Front-view-of-mixed-race-femal-293284573-2.jpg",
      "https://www.aplaceformom.com/image/web-lighthouse/prod/assisted-living-services.jpg?t=default",
    ],
  },
  {
    id: 5,
    title: "Cooking Preparations",
    description:
      "Healthy and customized meal preparation catering to dietary needs and personal preferences.",
    points: [
      "Preparation of nutritious and balanced meals",
      "Special diet considerations (diabetic, low-sodium, etc.)",
      "Grocery shopping and meal planning",
      "Safe food handling and hygiene",
      "24/7 Availability",
    ],
    images: [
      "https://broomees.com/attachments/blogs/f3fde66a4e1ef85bc59cbb8e8dc540d2.png",
      "https://st2.depositphotos.com/3785099/7401/i/950/depositphotos_74013483-stock-photo-young-woman-cooking-in-kitchen.jpg",
      "https://media.istockphoto.com/id/602324674/photo/its-dinner-time.jpg?s=612x612&w=0&k=20&c=V2Rz8jYRD9DgkGBYva4aM9QbfFMOypEcZTs5cmg1g9U=",
    ],
  },
  {
    id: 3,
    title: "Cleaning Services",
    description:
      "Professional cleaning services ensuring a hygienic and safe living environment for patients and seniors.",
    points: [
      "Dusting and vacuuming all living spaces",
      "Bathroom and toilet sanitation",
      "Kitchen cleaning and dishwashing",
      "Laundry and bed linen change",
      "24/7 Availability",
    ],
    images: [
      "https://plus.unsplash.com/premium_photo-1667520405114-47d3677f966e?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y2xlYW5pbmclMjBzZXJ2aWNlc3xlbnwwfHwwfHx8MA%3D%3D",
      "https://images.airtasker.com/v7/https://airtasker-seo-assets-prod.s3.amazonaws.com/en_AU/1724131557297-couch-cleaning.jpg",
      "https://carpetcleanermarketingmasters.com/wp-content/uploads/2025/01/chileshelumina_94325_close_up_shot_of_a_home_service_profession_16e8f099-26a4-4d20-afd5-e3612a7a1baf-1080x675.png",
    ],
  },
  {
    id: 13,
    title: "Attenders For Hospitals",
    description:
      "Attenders providing support with personal care, mobility, and emotional comfort during hospital visits.",
    points: [
      "Assisting with daily activities",
      "Ensuring timely intake as per prescription",
      "Keeping the patient’s surroundings hygienic",
      "Providing comfort and interaction.",
      "24/7 Availability",
    ],
    images: [
      "https://img.freepik.com/free-photo/medium-shot-health-worker-helping-patient_23-2148894881.jpg?t=st=1740384141~exp=1740387741~hmac=a34bebedad202d08a219cb894cda74893a712e85ffe5a87bf7ca76dfd559aead&w=1380",
      "https://img.freepik.com/free-photo/side-view-nurse-pushing-disabled-patient-wheel-chair_23-2147861489.jpg?t=st=1740384263~exp=1740387863~hmac=f737fec812251d127e778c98d06951137d7869b1b6ab25406b0c4b7a0d4c4c9b&w=1380",
      "https://img.freepik.com/free-photo/nurses-are-well-good-taken-care-elderly-patients-hospital-bed-patients-medical-healthcare-concept_1150-21703.jpg?t=st=1740384352~exp=1740387952~hmac=6b89360b84d15eac33c9b8f1da608b8d5fc880f05e33505f3497d47b3deee22c&w=1380",
    ],
  },

];

const ServicesCard = () => {
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % cardData[0].images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="ServicesCard-section py-5">
      <div className="container text-center">
        <p className="ServicesCard-badge">OUR SERVICES</p>
        <h2 className="ServicesCard-title mt-2">
          How 24 X 7 Home Care Services Work
        </h2>
        <p className="ServicesCard-subtitle mt-2">
          We follow a clear, simple process to ensure that our 24 X 7 Home Care
          Services meet your loved one’s needs efficiently and effectively.
        </p>
        <div className="row justify-content-center align-items-start mt-5">
          {cardData.map((card) => (
            <div key={card.id} className="col-md-5 mx-3 mb-5 ServicesCard-card">
              <a href="/clientform" style={{ textDecoration: "none" }}>
                <div className="ServicesCard-image-container">
                  <img
                    src={card.images[imageIndex]} // Changing images dynamically
                    alt={card.title}
                    className="img-fluid ServicesCard-image"
                  />
                </div>
                <div className="ServicesCard-content text-start p-4">
                  <h3 className="ServicesCard-subtitle-bold mt-2 zoom-effect">
                    {card.title.toUpperCase()}
                  </h3>

                  <p className="ServicesCard-text mt-3">{card.description}</p>
                  <ul className="ServicesCard-list mt-3">
                    {card.points.map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                  </ul>
                </div>
                <div
                  className="ServiceCard-badges"
                  style={{ alignItems: "center" }}
                >
                  <button className="ServicesCard-badge">APPLY NOW</button>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesCard;
